import { DateTime } from 'luxon';
import { capitalize } from 'vue';

import * as FilterComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
import LogicalOperator from '@/common/models/query-params/FilterLogicalOperator.enum';
import { toServerDateTimeNoTimezone } from '@/globals';
import i18n from '@/vueI18n';

import { Filter } from '..';
import Status from './CampaignStatus.enum';

export interface ICampaignStatusOption {
  value: string;
  name: string;
  filters: Filter[];
  logicalOperator: string | undefined;
}

export default class CampaignOptions {
  static getLocalizedOptionName(name: string): string {
    return capitalize(i18n.global.t(`states.${name}`));
  }

  static statusOptions(): ICampaignStatusOption[] {
    return [
      {
        value: Status.COMPLETED,
        name: CampaignOptions.getLocalizedOptionName('completed'),
        filters: [
          new Filter(
            'end_date',
            [toServerDateTimeNoTimezone(DateTime.local().startOf('day'))],
            FilterComparisonOperator.LESS_THAN,
          ),
        ],
        logicalOperator: undefined,
      },
      {
        value: Status.RUNNING,
        name: CampaignOptions.getLocalizedOptionName('running'),
        logicalOperator: LogicalOperator.AND,
        filters: [
          new Filter(
            'end_date',
            [toServerDateTimeNoTimezone(DateTime.local().plus({ days: -1 }))],
            FilterComparisonOperator.GREATER_THAN_OR_EQUAL,
          ),
          new Filter(
            'start_date',
            [toServerDateTimeNoTimezone(DateTime.local())],
            FilterComparisonOperator.LESS_THAN_OR_EQUAL,
          ),
        ],
      },
      {
        value: Status.UPCOMING,
        name: CampaignOptions.getLocalizedOptionName('upcoming'),
        filters: [
          new Filter(
            'start_date',
            [toServerDateTimeNoTimezone(DateTime.local())],
            FilterComparisonOperator.GREATER_THAN,
          ),
        ],
        logicalOperator: undefined,
      },
    ];
  }
}
